import { render, staticRenderFns } from "./ChangeLocation.vue?vue&type=template&id=120eef34&scoped=true"
import script from "./ChangeLocation.vue?vue&type=script&lang=js"
export * from "./ChangeLocation.vue?vue&type=script&lang=js"
import style0 from "./ChangeLocation.vue?vue&type=style&index=0&id=120eef34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120eef34",
  null
  
)

export default component.exports